// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".other-user-group-list[data-v-2c4bcf3a]{width:610px;max-height:240px;font-size:16px;border:1px solid #ccc}.other-user-group-list .list-body[data-v-2c4bcf3a]{overflow-y:scroll;overflow-x:auto}.other-user-group-list .list-body .group[data-v-2c4bcf3a]{padding:8px;border-bottom:1px solid #dcdcdc}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
